<template>
  <div>
    <el-row>
      <PaymentAndInvoicingReportFilters
        @onYearSelected="OnYearSelected"
        @onMonthSelected="OnMonthSelected"
        @PaymentSelected="OnPaymentSelected"
      />
    </el-row>
    <el-row>
      <PaymentAndInvoicingReportTable
        :TabSelected="ActualTabValue"
        :YearSelected="yearSelected"
        :MonthSelected="monthSelected"
        :PaymentSelected="PaymentSelected"
      />
    </el-row>
  </div>
</template>

<script>
import PaymentAndInvoicingReportTable from "@/components/fiances/reports/table/PaymentAndInvoicingReportTable";
import PaymentAndInvoicingReportFilters from "@/components/fiances/reports/filters/PaymentAndInvoicingReportFilters";

const actualYear = new Date().getFullYear();

export default {
  name: "PaymentAndInvoicingReport",
  components: {
    PaymentAndInvoicingReportTable,
    PaymentAndInvoicingReportFilters
  },
  props: {
    TabSelected: {
      type: String,
      defaul: "",
      required: true
    }
  },
  data() {
    return {
      yearSelected: actualYear,
      monthSelected: 0,
      PaymentSelected: ""
    };
  },

  mounted() {},
  computed: {
    ActualTabValue() {
      return this.TabSelected;
    }
  },
  methods: {
    OnYearSelected(year) {
      this.yearSelected = year;
    },
    OnMonthSelected(month) {
      this.monthSelected = month;
    },
    OnPaymentSelected(value) {
      this.PaymentSelected = value;
    }
  }
};
</script>

<style scoped></style>
